import { render, staticRenderFns } from "./EndorsementManage.vue?vue&type=template&id=4f33c3c4&"
import script from "./EndorsementManage.vue?vue&type=script&lang=js&"
export * from "./EndorsementManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports